import { createFileRoute, Navigate, Outlet, useRouterState } from "@tanstack/react-router";
import { useAuth } from "@/features/auth";

const Component = () => {
  const { user } = useAuth();
  const isUnsubscribeRoute = useRouterState({
    select: (state) => {
      if (state.location.pathname.startsWith("/notifications/unsubscribe")) {
        return true;
      }

      return state.matches.some((match) => String(match.routeId).includes("/notifications/unsubscribe"));
    },
  });

  // Unsubscribe must remain reachable for logged-in users; skip the public auth bounce.
  if (isUnsubscribeRoute) {
    return <Outlet />;
  }

  if (user?.current_user_id) {
    return <Navigate to="/consent-solutions" />;
  }

  return <Outlet />;
};

const Route = createFileRoute("/_public")({
  component: () => <Component />,
});

export { Route };
